import { FilterMatchMode } from 'primereact/api';

export const initialFormData = {
    firstName: '',
    lastName: '',
    tcNumber: null,
    phone: null,
    address: '',
    country: null,
    city: '',
    postalCode: null,
    // Geçici seçim için (form input alanları)
    chassis: '',
    selectedPlate: '',
    // Çoklu şasi listesi
    chassisList: []
};

export const initialFilters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    surname: { value: null, matchMode: FilterMatchMode.CONTAINS },
    identityNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    phoneNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    address: { value: null, matchMode: FilterMatchMode.CONTAINS },
    chassisNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    licensePlate: { value: null, matchMode: FilterMatchMode.CONTAINS }
};